<div class="flex-header mat-dialog-title" translate>Change Email</div>
<div class="flex-content">
  <form [formGroup]="changeEmailForm" #formDir="ngForm">
    <div>
      <tyl-form-field label="Current Email" style="width: 100%">
        <input matInput aria-label="Current Email" id="txtCurrentEmail"
               type="text" formControlName="currentEmail" required>
      </tyl-form-field>
    </div>
    <div>
      <tyl-form-field label="New Email" [errorMessage]="newEmailError" style="width: 100%">
        <input matInput aria-label="New Email" id="txtNewEmail" type="text"
               formControlName="newEmail" required>
      </tyl-form-field>
    </div>
    <div>
      <tyl-form-field label="Re-Enter Email" [errorMessage]="repeatNewEmailError" style="width: 100%">
        <input matInput aria-label="Re-enter New Email" id="txtRepeatNewEmail" type="text"
               formControlName="repeatNewEmail" required>
      </tyl-form-field>
    </div>
  </form>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>

